import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { AddParticipantRequest } from "@/api/types";
import { queryKeys } from "./queryKeys";
import { useConflictToast } from "./useConflictToast";

export function useParticipants(tripId: string | undefined) {
  return useQuery({
    queryKey: tripId ? queryKeys.participants(tripId) : ["participants", "none"],
    queryFn: () => api.listParticipants(tripId!),
    enabled: !!tripId,
  });
}

export function useAddParticipant(tripId: string) {
  const qc = useQueryClient();
  const onConflict = useConflictToast();
  return useMutation({
    mutationFn: (body: AddParticipantRequest) => api.addParticipant(tripId, body),
    onSuccess: () =>
      qc.invalidateQueries({ queryKey: queryKeys.participants(tripId) }),
    onError: (err) => onConflict(err, [queryKeys.participants(tripId)]),
  });
}

export function useRemoveParticipant(tripId: string) {
  const qc = useQueryClient();
  const onConflict = useConflictToast();
  return useMutation({
    mutationFn: (participantId: string) =>
      api.removeParticipant(tripId, participantId),
    onSuccess: () =>
      qc.invalidateQueries({ queryKey: queryKeys.participants(tripId) }),
    onError: (err) => onConflict(err, [queryKeys.participants(tripId)]),
  });
}
